import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendService } from '../backend/backend.service';
import { AssistantChatRating } from '../../interfaces/assistant-chat.interface';

@Injectable({ providedIn: 'root' })
export class AssistantChatRatingService {
  private readonly backendService = inject(BackendService);

  public rate(threadId: string, requestId: string, rating: AssistantChatRating): Observable<void> {
    return this.backendService.create(
      '/assistant/ratings',
      { thread_id: threadId, request_id: requestId, rating },
      { skipLoader: true, throwErrors: true },
    );
  }
}
